// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
 
  .subscription {
    display: flex;
    padding: 10px;
    border: 1px solid #a1a1a1;
    border-radius: 10px;
    margin: 20px 10px;
    box-shadow: 1px 3px 7px 0px lightgrey;
  }

  .subscription-content {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .subscription-name {
    font-weight: bold;
    padding: 4px 0px;
  }
  .subscription-period {
    text-transform: uppercase;
    font-size: 12px;
  }
  .subscription-info {
    _text-transform: uppercase;
    font-size: 12px;
  }
  .subscription-status {
    position: absolute;
    right: 10px;
    top: 30%;
    display: inline-block;
    font-weight: bold;
    font-size: 20px;
  }

  .subscription.paid {
    border: 1px solid #22bedc;
  }
  .subscription.paid > .subscription-content > .subscription-status {
    color: #22bedc;
  }
  .subscription.notpaid {
    border: 1px solid #d53d0e;
  }
  .subscription.notpaid > .subscription-content > .subscription-status {
    color: #d53d0e;  
  }
  

  .device-pic {
    max-height: 60px;
  }
  .device-content {
    padding: 0px 10px;
  }
  .device-name {
    padding: 5px;
  }
  .device-status {
    padding: 5px;
  }
  .img-container {
    margin: 0px 10px;
  }

  .billing-footer {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  .billing-header {
    font-size: 18px;
    font-weight: bold;
    padding: 10px 0px;
  }
  `, "",{"version":3,"sources":["webpack://./src/app/components/login-page/billing.ts"],"names":[],"mappings":";;EAEE;IACE,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,eAAe;EACjB;EACA;KACE,yBAA0B;IAC1B,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;;;EAGA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB","sourcesContent":["\n \n  .subscription {\n    display: flex;\n    padding: 10px;\n    border: 1px solid #a1a1a1;\n    border-radius: 10px;\n    margin: 20px 10px;\n    box-shadow: 1px 3px 7px 0px lightgrey;\n  }\n\n  .subscription-content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n  }\n  .subscription-name {\n    font-weight: bold;\n    padding: 4px 0px;\n  }\n  .subscription-period {\n    text-transform: uppercase;\n    font-size: 12px;\n  }\n  .subscription-info {\n    _text-transform: uppercase;\n    font-size: 12px;\n  }\n  .subscription-status {\n    position: absolute;\n    right: 10px;\n    top: 30%;\n    display: inline-block;\n    font-weight: bold;\n    font-size: 20px;\n  }\n\n  .subscription.paid {\n    border: 1px solid #22bedc;\n  }\n  .subscription.paid > .subscription-content > .subscription-status {\n    color: #22bedc;\n  }\n  .subscription.notpaid {\n    border: 1px solid #d53d0e;\n  }\n  .subscription.notpaid > .subscription-content > .subscription-status {\n    color: #d53d0e;  \n  }\n  \n\n  .device-pic {\n    max-height: 60px;\n  }\n  .device-content {\n    padding: 0px 10px;\n  }\n  .device-name {\n    padding: 5px;\n  }\n  .device-status {\n    padding: 5px;\n  }\n  .img-container {\n    margin: 0px 10px;\n  }\n\n  .billing-footer {\n    margin-top: 30px;\n    display: flex;\n    justify-content: center;\n  }\n  .billing-header {\n    font-size: 18px;\n    font-weight: bold;\n    padding: 10px 0px;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
